import * as React from "react";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
const Icon = (props) => {
  var _a;
  const { getIconPath } = useTheme();
  const src = getIconPath(props.modifiers);
  const BEM = () => {
    const classArray = ["icon"];
    if (props.size) {
      classArray.push("icon--" + props.size);
    }
    if (props.align) {
      classArray.push("icon--align-" + props.align);
    }
    if (props.verticalAlign) {
      classArray.push("icon--vertical-align-" + props.verticalAlign);
    }
    if (props.hasBackground) {
      classArray.push("icon--background");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("svg", { className: BEM(), style: props.style, focusable: "false", "aria-hidden": (_a = props["aria-hidden"]) != null ? _a : true }, /* @__PURE__ */ React.createElement("use", { xlinkHref: src, href: src }));
};
export {
  Icon
};
